<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CdDQ0O/images/MyCoverImage.jpg?1733085642992" alt="This image is the cover for the book Rules of Engagement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rules of Engagement
      </h1>
      <p class="bookDescription body article font2">
        <b>The son of a celebrated journalist searches for the truth to his father’s dark past<br/><br/></b>Everyone knows Hawkins is not the reporter his father—a famous war correspondent—was. Hawkins’s fondness for drink disqualifies him from the kind of reporting that is his birthright. But with a father like his, the newspaper cannot let him go. Instead, the board has asked him to write a biography of his father—a fluff project designed to keep Hawkins out of trouble. But the assignment leads to unsuspected, shocking revelations. Hawkins’s father made his name as a war correspondent in Vietnam, where terrible secrets still remain buried. When Hawkins digs into the story of one raid—a skirmish that produced four heroes, a future president among them—the horrible truth he discovers will change his life forever. This ebook features an illustrated biography of Brian Freemantle including rare photos from the author’s personal collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Freemantle
      </h2>
      
      <p class="authorDescription body article">Brian Freemantle (b. 1936) is one of Britain&rsquo;s most acclaimed authors of spy fiction. His novels have sold over ten million copies worldwide. Born in Southampton, Freemantle entered his career as a journalist, and began writing espionage thrillers in the late 1960s. <i>Charlie M</i> (1977) introduced the world to Charlie Muffin and won Freemantle international success. He would go on to publish fourteen titles in the series.&#160;Freemantle has written dozens of other novels, including two about Sebastian Holmes, an illegitimate son of Sherlock Holmes, and the Cowley and Danilov series, about a Russian policeman and an American FBI agent who work together to combat organized crime in the post&ndash;Cold War world. Freemantle lives and works in Winchester, England.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1afadd3c